// @flow
import React, { Component } from "react";
import { get } from "lodash";
import mediator from "@tvg/mediator";
import type { RaceProgram } from "@tvg/types/Race";
import type { UserOptedInPromos } from "@tvg/types/User";
import { connect } from "react-redux";
import ModalV2 from "@tvg/atomic-ui/_templates/ModalV2";
import tvgConf from "@tvg/conf";
import PoolsNInfo, { type TabKey } from "@tvg/atomic-ui/_templates/PoolsNInfo";
import performanceUtils from "@tvg/utils/performanceUtils";
import {
  setSelectedPoolsNInfoTab,
  togglePoolsNInfoModal,
  type Actions
} from "../actions/poolsNInfo";
import Container from "./PoolsInfoContainer/index";

type Props = {
  currentRace: RaceProgram,
  selectedPoolsNInfoTab: TabKey,
  isOpen: boolean,
  isVideoShown: boolean,
  renderOnModal: boolean,
  dispatch: Dispatch<Actions>,
  profile: string,
  hasPromoBadge: boolean,
  optedInPromos: UserOptedInPromos,
  enableAllRaceChanges: boolean,
  hasWebSockets: boolean,
  races: RaceProgram[]
};

export class PoolsNInfoComponent extends Component<Props> {
  static defaultProps = {
    isOpen: false,
    isVideoShown: false,
    renderOnModal: true,
    hasPromoBadge: false,
    optedInPromos: {},
    enableAllRaceChanges: false,
    hasWebSockets: false,
    races: []
  };

  componentDidMount() {
    performanceUtils.measure("page_load", { page: "pools_and_info" });
  }

  shouldComponentUpdate(nextProps: Props) {
    return (
      nextProps.selectedPoolsNInfoTab !== this.props.selectedPoolsNInfoTab ||
      nextProps.isOpen !== this.props.isOpen ||
      nextProps.isVideoShown !== this.props.isVideoShown ||
      nextProps.currentRace !== this.props.currentRace ||
      nextProps.races.length !== this.props.races.length
    );
  }

  selectTab = (tab: TabKey) =>
    tab ? this.props.dispatch(setSelectedPoolsNInfoTab(tab)) || true : false;

  closeModal = () => {
    this.props.dispatch(togglePoolsNInfoModal(false));
    mediator.base.dispatch({
      type: "POOLS_INFO:OPEN_CLOSE",
      payload: {
        open: false,
        module: "Pools & Info Modal"
      }
    });
  };

  buildSubtitle = () => {
    if (tvgConf().device !== "mobile") {
      return "";
    }

    const trackName = get(this.props, "currentRace.track.trackName");
    const raceNumber = get(this.props, "currentRace.raceNumber");
    return `${trackName} ${raceNumber && `R${raceNumber}`}`;
  };

  renderPoolsNInfo = () => (
    <PoolsNInfo
      defaultTab={this.props.selectedPoolsNInfoTab}
      onTabClick={this.selectTab}
      raceTypeCode={get(this.props, "currentRace.type.code", "T")}
      shouldRenderInline={!this.props.renderOnModal}
      subTitle={this.buildSubtitle()}
      isGreyhound={get(this.props, "currentRace.isGreyhound", false)}
    >
      <Container
        currentRace={this.props.currentRace}
        tabSelected={this.props.selectedPoolsNInfoTab}
        trackAbbr={get(this.props, "currentRace.track.trackCode")}
        wagerProfile={this.props.profile}
        raceNumber={this.props.currentRace.raceNumber}
        isOpen={this.props.isOpen}
        shouldRenderInline={!this.props.renderOnModal}
        device={tvgConf().device}
        hasPromoBadge={this.props.hasPromoBadge}
        optedInPromos={this.props.optedInPromos}
        enableAllRaceChanges={this.props.enableAllRaceChanges}
        hasWebSockets={this.props.hasWebSockets}
        races={this.props.races}
      />
    </PoolsNInfo>
  );

  renderPoolsNInfoModal = () => (
    <ModalV2
      title="Pools & Info"
      subtitle={this.buildSubtitle()}
      animation="bottom"
      qaLabel="modal-PoolsNInfo"
      hasVideoOffset={this.props.isVideoShown}
      onClose={this.closeModal}
      isOpen={this.props.isOpen}
    >
      {() => <div>{this.renderPoolsNInfo()}</div>}
    </ModalV2>
  );

  render() {
    return (
      get(this.props, "currentRace.track.trackCode", false) &&
      (this.props.renderOnModal
        ? this.renderPoolsNInfoModal()
        : this.renderPoolsNInfo())
    );
  }
}

export default connect(
  (store, props) => ({
    selectedPoolsNInfoTab: store.RaceProgramPoolsNInfo.selectedPoolsNInfoTab,
    hasWebSockets: get(store, "capi.featureToggles.enableWebSocketsTVG", false),
    currentRace: props.currentRace,
    profile: get(store, "userData.user.profile"),
    hasPromoBadge: get(store, "capi.featureToggles.promosDisplayBadge", false),
    optedInPromos: get(store, "userData.optedInPromos", {})
  }),
  (dispatch: Dispatch<Actions>) => ({ dispatch })
)(PoolsNInfoComponent);
